// Utilitário para detectar ambiente e capacidades do sistema
export class EnvironmentDetector {
  
  // Detectar se estamos em desenvolvimento ou produção
  static isDevelopment() {
    return process.env.NODE_ENV === 'development';
  }

  // Detectar se WebRTC está disponível e funcionando
  static async testWebRTCCapability() {
    try {
      // Verificar se APIs estão disponíveis
      if (!window.RTCPeerConnection || !navigator.mediaDevices?.getUserMedia) {
        console.log('🚫 WebRTC APIs não disponíveis');
        return false;
      }

      // Testar conexão com servidor local (desenvolvimento)
      if (this.isDevelopment()) {
        try {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 3000);
          
          const response = await fetch('http://localhost:3001/api/health', {
            method: 'GET',
            signal: controller.signal
          });
          
          clearTimeout(timeoutId);
          
          if (response.ok) {
            console.log('✅ Servidor local Flask disponível - usando WebRTC');
            return true;
          }
        } catch (error) {
          console.log('⚠️ Servidor local não disponível - usando HTTP fallback');
          return false;
        }
      }

      // Em produção, primeiro testar endpoint básico
      try {
        console.log('🧪 Testando endpoint básico...');
        const testResponse = await fetch('/api/test', {
          method: 'GET'
        });
        
        if (testResponse.ok) {
          const testData = await testResponse.json();
          console.log('✅ Endpoint básico funcionando:', testData);
          
          // Se endpoint básico funciona, testar WebRTC
          if (testData.openaiKeyConfigured && testData.openaiImportStatus === 'success') {
            console.log('🔄 Testando WebRTC...');
            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 5000);
            
            const sessionResponse = await fetch('/api/realtime/session', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({}),
              signal: controller.signal
            });
            
            clearTimeout(timeoutId);

            if (sessionResponse.ok) {
              // Testar se consegue criar PeerConnection
              const pc = new RTCPeerConnection();
              pc.close();
              console.log('✅ WebRTC disponível no deploy');
              return true;
            } else {
              console.log('⚠️ Erro na sessão WebRTC:', sessionResponse.status);
            }
          } else {
            console.log('⚠️ OpenAI não configurado corretamente no deploy');
          }
        } else {
          console.log('⚠️ Endpoint básico falhou:', testResponse.status);
        }
      } catch (error) {
        console.log('⚠️ Erro nos testes de deploy:', error.message);
      }

      return false;
    } catch (error) {
      console.log('❌ Erro ao testar WebRTC:', error);
      return false;
    }
  }

  // Detectar melhor método de chat por voz
  static async getBestChatMethod() {
    const webRTCAvailable = await this.testWebRTCCapability();
    
    if (webRTCAvailable) {
      return {
        method: 'webrtc',
        endpoint: this.isDevelopment() 
          ? 'http://localhost:3001/api/realtime/session'
          : '/api/realtime/session',
        description: 'WebRTC Realtime (Melhor qualidade)'
      };
    } else {
      return {
        method: 'http',
        endpoint: '/api/chat/stream',
        description: 'HTTP Streaming (Compatível com deploy)'
      };
    }
  }

  // Verificar se microfone está disponível
  static async testMicrophoneAccess() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      stream.getTracks().forEach(track => track.stop());
      return true;
    } catch (error) {
      console.error('❌ Microfone não disponível:', error);
      return false;
    }
  }
}

export default EnvironmentDetector;
